import React from 'react';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { Button } from '@mui/material';
import clsx from 'clsx';

const PrimaryButton = ({ style, children, className, ...rest }) => {
	const theme = useTheme();
	const useStyles = makeStyles(() => ({
		root: {
			justifyContent: 'center',
			padding: '0',
		},
		button: {
			backgroundColor: theme.palette.primary.button,
			alignItems: 'center',
			justifyContent: 'center',
			color: 'white',
			marginLeft: '8px',
			fontSize: '12px',
			padding: '8px 24px',
			letterSpacing: '0.08em',
			borderRadius: '24px',
			border: '1px solid white',
			'&:hover': {
				backgroundColor: theme.palette.primary.main,
			},
			...style,
			[theme.breakpoints.down('md')]: {
				fontSize: '12px',
			},
		},
	}));

	const classes = useStyles();

	return (
		<React.Fragment>
			<Button
				variant='contained'
				className={clsx(classes.button, className)}
				{...rest}>
				{children}
			</Button>
		</React.Fragment>
	);
};

export default PrimaryButton;
